import { useCallback } from "react";
import { Explorer } from "./Explorer";
import { padHex } from "viem";
import { submitBatch } from "./batch";
import { AccountButton, useSessionClient } from "@latticexyz/entrykit/internal";
// import { observer } from "@latticexyz/explorer/observer";
// import { storeSync } from "./storeSync";
import { localUserOpExecutor } from "./transports/localUserOps";

export const Playground = () => {
  const { data: client } = useSessionClient();

  // useEffect(() => {
  //   const explorerUrl =
  //     window.location.hostname === "localhost" ? "http://localhost:13690" : "https://explorer.mud.dev";
  //   client?.extend(observer({ explorerUrl, waitForTransaction: storeSync.waitForTransaction }));
  // }, [client]);

  const onClickUserOp = useCallback(async () => {
    if (!client) return;
    const messageHex = padHex("0x01", { size: 32 });
    const result = await submitBatch(client, 1, [messageHex]);
    console.log("roundtrip", result?.roundtrip);
  }, [client]);

  const onClickTx = useCallback(async () => {
    if (!client) return;
    const messageHex = padHex("0x01", { size: 32 });
    const result = await submitBatch(localUserOpExecutor, 1, [messageHex], { useWriteContract: true });
    console.log("roundtrip", result?.roundtrip);
  }, [client]);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "180px 1fr",
        minHeight: "100vh",
      }}
    >
      <div>
        <AccountButton />
        {client && (
          <button className="border-2 border-white p-2 m-2" onClick={onClickUserOp}>
            Click to send authentic doom user operation
          </button>
        )}
        {localUserOpExecutor && (
          <button className="border-2 border-white p-2 m-2" onClick={onClickTx}>
            Click to send authentic doom transaction
          </button>
        )}
      </div>
      <Explorer />
    </div>
  );
};
